"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _arrowDropDown = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-drop-down"));
var _done = _interopRequireDefault(require("material-ui/svg-icons/action/done"));
var _List = require("material-ui/List");
var _Popover = _interopRequireDefault(require("material-ui/Popover"));
require("./PopupListWithFilter.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SelectableList = (0, _List.makeSelectable)(_List.List);
var PopupListWithFilter = /*#__PURE__*/function (_Component) {
  _inherits(PopupListWithFilter, _Component);
  var _super = _createSuper(PopupListWithFilter);
  function PopupListWithFilter(props) {
    var _this;
    _classCallCheck(this, PopupListWithFilter);
    _this = _super.call(this, props);
    _this.state = {
      display: false,
      value: _this.props.selectedValue || 'No Selection'
    };
    return _this;
  }
  _createClass(PopupListWithFilter, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        display: !this.state.display
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        display: false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        'fontFamily': this.state.value
      };
      var fonts = [];
      var style = {};

      //@NOTE THIS apears to be assuming a list of font family names...
      this.props.options && this.props.options.map(function (option) {
        style = {
          'fontFamily': option.value
        };
        fonts.push( /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: option.id,
          primaryText: option.value,
          value: option.value,
          style: style,
          leftIcon: _this2.state.value === option.value ? /*#__PURE__*/_react["default"].createElement(_done["default"], null) : /*#__PURE__*/_react["default"].createElement("span", {
            className: "empty-icon"
          })
        }));
        return null;
      });
      var titleNode = /*#__PURE__*/_react["default"].createElement("div", {
        className: "font-list-header"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-list-header-icon"
      }, /*#__PURE__*/_react["default"].createElement(_done["default"], {
        style: {
          verticalAlign: 'middle',
          marginLeft: 0,
          marginRight: 12
        }
      })), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles
      }, " ", this.state.value, " "));
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "cms-popover",
        onClick: this.handleClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cms-list-item",
        id: "select-font-style"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-5 left-item"
      }, this.props.label, "\xA0"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-7 right-item"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "list-item-text",
        style: styles
      }, this.state.value, " "), /*#__PURE__*/_react["default"].createElement(_arrowDropDown["default"], null))), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        className: "style-selector-list",
        open: this.state.display,
        onRequestClose: this.handleClose,
        anchorEl: document.getElementById("select-font-style"),
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        }
      }, titleNode, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement(SelectableList, {
        value: location.pathname,
        onChange: this.handleChange
      }, fonts))));
    }
  }]);
  return PopupListWithFilter;
}(_react.Component);
var _default = PopupListWithFilter;
exports["default"] = _default;